// src/pages/Login.js
import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import './Login.css';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
 : 'https://demo.myssa.net/api';

const Login = ({ setIsAuthenticated, setUser }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },

        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || "Nom d'utilisateur ou mot de passe incorrect.");
        return;
      }

      setUser(data);
      localStorage.setItem('user', JSON.stringify(data));
      setIsAuthenticated(true);
      setRedirect(true);

    } catch (err) {
      setError('Impossible de contacter le serveur.');
    } finally {
      setLoading(false);
    }
  };

  if (redirect) {
    return <Navigate to="/home" />;
  }

  return (
    <div
      className="login-container"
      style={{
        position: 'relative',
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* Image de fond qui couvre TOUTE la page, sans zone vide ni couleur visible autour */}
      <img
        src="/logo MYSSA.png"
        alt=""
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
          zIndex: 0,
        }}
      />

      {/* Overlay sombre pour lisibilité du formulaire */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.30)',
          zIndex: 1,
        }}
      />

      {/* Formulaire */}
      <form
        onSubmit={handleLogin}
        style={{
          position: 'relative',
          zIndex: 2,
           marginTop: '180px',      // ← décale vers le bas (négatif = vers le haut)
    marginLeft: '-100px',
          backgroundColor: 'rgba(0, 0, 0, 0.55)',
          padding: '36px 28px',
          borderRadius: '12px',
          display: 'flex',
          flexDirection: 'column',
          minWidth: '320px',
          backdropFilter: 'blur(6px)',
          border: '1px solid rgba(255,255,255,0.15)',
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        }}
      >
        <label htmlFor="username" style={{ color: '#fff', marginBottom: '6px' }}>
          Nom d'utilisateur :
        </label>
        <input
          type="text"
          id="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          style={{
            padding: '8px 10px',
            borderRadius: '6px',
            border: '1px solid rgba(255,255,255,0.3)',
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: '#fff',
            outline: 'none',
          }}
        />

        <label htmlFor="password" style={{ color: '#fff', marginTop: '14px', marginBottom: '6px' }}>
          Mot de passe :
        </label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{
            padding: '8px 10px',
            borderRadius: '6px',
            border: '1px solid rgba(255,255,255,0.3)',
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: '#fff',
            outline: 'none',
          }}
        />

        {error && (
          <p style={{
            color: '#ff6b6b',
            fontSize: '13px',
            marginTop: '12px',
            background: 'rgba(255,0,0,0.15)',
            padding: '8px 10px',
            borderRadius: '5px',
            textAlign: 'center',
          }}>
            ⚠️ {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            marginTop: '30px',
            padding: '10px',
            borderRadius: '7px',
            border: 'none',
            backgroundColor: '#2ecc71',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '15px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1,
            transition: 'opacity 0.2s',
          }}
        >
          {loading ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
};

export default Login;